/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Expandable from './Expandable/index'
import Installments from './Installments/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Installment/Content"
  
}) {
  return (<React.Fragment
>
<Installments
  viewPath={`${viewPath}/Installments`}
/>
<Expandable
  viewPath={`${viewPath}/Expandable`}
/>
{children}
</React.Fragment>)
}